import { RECORDS_PER_PAGE } from '@/constants/data';
import BaseService from './base.service';

const baseService = new BaseService('campusgroup-admin');

export default {
  getCampusGroupAdmins: (params: any = {}) => {
    const queryParams = new URLSearchParams({
      page: (params.page || 1).toString(),
      perPage: RECORDS_PER_PAGE.toString(),
    });

    if (params.search && params.search.trim() !== '') {
      queryParams.append('search', params.search);
    }

    if (params.country) {
      queryParams.append('country_id', params.country);
    }

    if (params.active !== null && params.active !== undefined) {
      queryParams.append('active', params.active.toString());
    }

    if (params.campus_group_id) {
      queryParams.append('campus_group_id', params.campus_group_id);
    }

    return baseService.get(`findAll?${queryParams}`);
  },

  createCampusGroupAdmin: (campusGroupAdmin: any) => baseService.post('create', campusGroupAdmin),

  updateCampusGroupAdmin: (id: number, campusGroupAdmin: any) => baseService.put(`update/${id}`, campusGroupAdmin),

  getCampusGroupAdmin: (id: number) => baseService.get(`findOne/${id}`),

  getAvailableCampusGroups: (params: any = {}) => {
    const queryParams = new URLSearchParams({
      ...params.country_id && { country_id: params.country_id },
      ...params.school_group_id && { school_group_id: params.school_group_id },
    });
    return baseService.get(`available-campus-groups?${queryParams}`);
  },

  getCampusGroupsBySchoolGroup: (schoolGroupId: number) => {
    const queryParams = new URLSearchParams({
      school_group_id: schoolGroupId.toString(),
    });
    return baseService.get(`available-campus-groups?${queryParams}`);
  },

  deleteMultipleCampusGroupAdmins: (ids: number[]) => baseService.del('delete-multiple', { ids }),
};
